// extracted by mini-css-extract-plugin
export default {"pagination":"productPage_pagination__4G3eD","pagination2":"productPage_pagination2__nMnqi"};